// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCMJSPlw03F88IvSRrq473I6GtgD_xBtE4",
  authDomain: "chat-app-1822e.firebaseapp.com",
  projectId: "chat-app-1822e",
  storageBucket: "chat-app-1822e.appspot.com",
  messagingSenderId: "290142937300",
  appId: "1:290142937300:web:23ae3bfd1c3ea632645b41",
  measurementId: "G-Z030G26YGT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore(app);
export default app;